import { useState } from 'react';
import { BsCaretRight } from 'react-icons/bs';
import CardH from 'src/components/cards-video/card-h';
import { SHOW_COMMEMORATE } from 'src/constants';
import { getFeatureImage } from 'src/utils/contents/get-image';

const SecFullH = ({ data, sectionH = false, eventDataLayer }) => {
  const [defalutData, setDefalutData] = useState({
    type_video: '',
    video_src: ''
  });
  const [counter, setCounter] = useState(0);
  if (data?.length > 0 && defalutData?.video_src === '') {
    setDefalutData({ type_video: data[0]?.type_video, video_src: data[0]?.video_src });
  }
  // console.log('SecFullH', defalutData);

  return (
    <>
      {data?.length > 0 && (
        <div className='section-wrapper' style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.7)' : '' }}>
          <div className='row'>
            <div className={`col-12 video-player ${sectionH ? '--small' : 'col-md-8'}`}>{data?.length > 0 && getFeatureImage(defalutData)}</div>

            <div className={`col-12 ${sectionH ? '' : 'col-md-4'} card-wrapper`}>
              <div className='playlist-head'>
                <div className='playlist-head-icon'>
                  <BsCaretRight />
                </div>
                <h2>Most Watched</h2>
                <span className='videos-number'>
                  <span> {counter + 1} </span> / <span> {data?.length} </span> Videos
                </span>
              </div>
              <div className='video-playlists playlist-custom-scroll --vertical'>
                <ul>
                  {data?.length > 0 &&
                    data.map((item, index) => (
                      <li
                        className={`w-100 ${counter === index ? 'active' : ''}`}
                        key={index}
                        onClick={() => {
                          setDefalutData({
                            type_video: item.type_video,
                            video_src: item.video_src
                          });
                          setCounter(index);
                        }}
                      >
                        <CardH
                          data={item}
                          number={index + 1}
                          //! DATALAYER
                          eventDataLayer={{
                            ...eventDataLayer,
                            data: {
                              title: item.title,
                              index: index + 1,
                              ...eventDataLayer.data
                            }
                          }}
                        />
                      </li>
                    ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SecFullH;
